module.exports = __webpack_public_path__ + "static/media/apple.75c18b83.png";